export default {
  scoreMetadata: {
    step: 'Step',
    createSelfTestsTitle: 'Self-assessment tests',
    appointTestsTitle: 'Assignment score',
    approvalTestsTitle: 'Sending the score for approval',
    editTestTitle: 'Edit the score',
    descriptionTitle: 'Description of the task/project',
    selectOfEvaluatedTitle: 'Select the evaluated',
    addingEvaluatedGroups: 'Adding groups of evaluators',
    selectExpertsByEvaluatedTitle:
      'Select evaluating experts, the new composition of participants will be sent for approval by the supervisor',
    appointTestsProcessTitle: 'Assigned',
    appointTestsProcessText:
      'You can close this window, tests will be assigned in the background. Refresh the page after a while to see the assigned tests.',
    approvalTestsProcessTitle: 'Sent',
    approvalTestsProcessText:
      'You can close this window, the tests will be sent in the background.',
    formLabels: {
      period: 'Set the assessment schedule',
      skipSelfEval: 'Without self-assessment',
      approvalBySupervisor: 'Confirmation by the supervisor in the assessment 360',
      approvalByEvaluated: 'Confirmation by the evaluated in the assessment 360',
      hideReport: 'Hide a report for the evaluated employee',
      enabledComments: 'Enable comments on the competence',
      requiredComments: 'Required comments on the competence',
      enabledDescription: 'Enable a description of a task/project',
      description: 'Description of the task/project',
    },
    formPlaceholders: {
      description: 'Describe the task or project for this assessment',
    },
    buttons: {
      startWithoutApproval: 'Start without approval',
      reApprove: 'Re-approve',
      addGroup: 'Add a group',
      assignApprover: 'Assign to the approver',
      removeApprover: 'Remove the approver',
    },
    tooltips: {
      approver: 'Approves the composition of the 360 assessment participants',
      period:
        'Users can take the test only during the specified time period. After the deadline, the test becomes unavailable for passing',
      changePeriod:
        'The schedule will change for the entire test group. Users can take the tests only during the specified time period. After the deadline, the tests becomes unavailable for passing',
      remind: ' Last reminder',
      closed: 'The test closed for passing',
    },
    menuReport: {
      forSupervisor: 'Report for supervisor',
      forEmployee: 'Report for employee',
    },
    uncompletedTest: 'Uncompleted test',
    canceledTest: 'Canceled test',
    teamReports: {
      title: 'Team reports',
      description: 'To create a team report, select a team from the list',
    },
    exportTypes: {
      pivotExport: 'Overall average scores',
      pivotTested: 'Completion status',
      gradePivotExport: 'Team statistics',
      usersGradePivotExport: 'Raw scores by team',
      scoreSkillsExport: 'Score of competencies',
      passingExport: 'Passing the assessment',
      massRoadmap: 'Development map',
      fixedRoadmaps: 'Fixed plans',
    },
    descriptions: {
      180: 'Test 180 - only the evaluated person and the team leader take part in the assessment',
      360: 'Test 360 - the entire team participates in the assessment and is automatically assigned to roles',
      soft: 'Soft skills are also “flexible skills” - universal competencies that are not related to a specific subject area, increasing the efficiency of work and interaction with other people',
      hard: 'Hard skills - professional skills that can be obtained in the learning process, this type of skills can be measured using an exam or testing',
      period:
        'Users will be able to complete the assessment only during the specified time period, after the deadline, the assessment will become unavailable.<br/>The start date of the period is the date on which notifications will be sent to start the assessment.<br/>If the process of approving the composition of participants is enabled, letters for approval of the composition will be sent immediately when you click on the button «Create score».',
      skipSelfEval:
        'The assessment is based on the 360 method, but the evaluated participant will not take the survey. The report on the completion of the evaluation will also not be available to the evaluated employee. You can turn on the report display at any time.',
      approvalBySupervisor:
        'The test will start only after the supervisor of the assessment 360 confirms the composition of the participants.',
      approvalByEvaluated:
        'The evaluated employee will be able to adjust the composition of participants and send the assessment to the supervisor for final approval.',
      hideReport:
        'The report will be hidden for the evaluated employee. The report can be displayed later, at any time during the assessment.',
      enabledComments: 'Comments on each competence are enabled when passing the assessment',
      requiredComments:
        'Required comments on each competence are enabled when passing the assessment',
      comments: {
        all: 'During the assessment process, respondents will be required to leave a comment for each competence',
        score:
          'During the assessment process, respondents will be required to leave a comment only for those competencies for which they will give a rating below or equal to the set one',
      },
      enabledDescription:
        'The employee will be able to describe the task or project for this assessment',
      addExpertGroups:
        'The limit has been reached. You can add a group if you delete the current one.',
    },
    commentTypes: {
      all: 'All',
      score: 'Below score',
    },
    reportIsUnavailable: {
      tests360: 'There are no passed 360 tests to create a report',
      personal: 'There are no passed tests to create a report',
    },
    // confirm dialogs
    confirmGetReport: {
      title: 'Create a report?',
      text: 'Not all team members have passed the test, the data obtained may be unreliable.',
      button: 'Yes, create',
    },
    confirmCreateTests: {
      title: 'Are you sure?',
      text: 'The testing period has expired',
      button: 'Yes, assign',
    },
    confirmCancelTest: {
      title: 'Cancel the test?',
      text: 'Are you sure you want to cancel the test? The test will be canceled and it will have to be run again.',
      button: 'Yes, cancel',
    },
    confirmReApproveTest: {
      title: 'Send the test for re-approval?',
      text: 'Are you sure you want to send the assessment for re-approval with the supervisor?',
      button: 'Yes, send',
    },
    confirmStartWithoutApproval: {
      title: 'Start the assessment without approval?',
      text: 'Are you sure you want to start the assessment without waiting for approval?',
      button: 'Yes, start',
    },
    confirmDeleteExpertGroup: {
      title: 'Delete the group {name}?',
      description: 'Any group changes will be applied to all assessments in this assignment',
      text: 'There are employees in the group. Really delete the group?',
    },
    confirmSetHiddenReports360: {
      hide: {
        title: 'Hide the reports from the evaluated employees?',
        text: 'The evaluated employees will not be able to view the report on the selected tests on the «Assigned to me» page.',
        button: 'Yes, hide',
      },
      show: {
        title: 'SHow the reports from the evaluated employees?',
        text: 'The evaluated employees will be able to view the report on the selected tests on the «Assigned to me» page.',
        button: 'Yes, show',
      },
    },
    confirmCloseTests360: {
      close: {
        title: 'Close the assessments for passing?',
        text: 'Employees participating in the assessment will not be able to take the tests.',
        button: 'Yes, close',
      },
      open: {
        title: 'Open the assessments for passing?',
        text: 'Employees participating in the assessment will be able to take the tests.',
        button: 'Yes, open',
      },
    },
    confirmCreateReminders: {
      title: 'Send reminders?',
      defaultText:
        'Emails will be sent to the participants of the selected tests with a reminder about the testing.',
      warningText:
        '{msg_count} emails will be sent to users who did not pass or did not agree on the assessment.',
      warningTextForClosedTests: 'Emails will not be sent to participants of closed tests',
      button: 'Yes, send',
    },
    confirmDeleteTests360: {
      title: 'Delete the score 360?',
      text: 'Deleted tests cannot be restored, and the generated report and development map will not be available to the user. Are you sure?',
    },
    confirmGetReport360: {
      title: 'Create a report?',
      text: 'Not all test participants filled out the questionnaire, the data obtained may be unreliable.',
      button: 'Yes, create',
    },
    confirmCreateRoadmap360: {
      title: 'Create a development plan?',
      text: 'Create a development plan based on this test',
      button: 'Yes, create',
    },
    //
    successMessages: {
      createSelfTests: {
        title: 'Testing has been successfully assigned',
        text: 'Letters with instructions for passing are sent to the e-mail addresses specified during registration',
      },
      appoint: {
        title: 'The score successfully assigned',
        text: 'Letters with instructions for passing are sent to the e-mail addresses specified during registration',
      },
      approval: {
        title: 'Testing sent for approval',
        text: 'The score sent for approval',
      },
      reject: {
        title: 'Testing rejected',
        text: 'The score sent for editing',
      },
      cancelled: {
        title: 'Testing cancelled',
        text: 'The score successfully cancelled',
      },
    },
    infoMessages: {
      selectedSoftSkills: 'Specializations that have soft skills are available for selection',
      selectedHardSkills: 'Specializations that have hard skills are available for selection',
      selectedAllSkills:
        'Specializations that have both types of skills are available for selection',
    },
    errorMessages: {
      createSelfTests: 'Failed to assign testing',
      getAutoExperts:
        'Failed to assigned as experts from the organizational structure. Team members will be assigned as experts.',
      appointAllTests: 'Failed to assign any tests',
      appointSomeTests: 'Some tests were not assigned',
      approvalAllTests: 'Failed to send any test for approval',
      approvalSomeTests: 'Some tests were not send for approval',
      approvedAllTests: 'Failed to approve the score',
      rejectAllTests: 'Failed to reject the score',
      checkStatuses: 'Failed to get test assignment status',
      changeStatus: 'Failed to change status the test',
      getDescription: 'Failed to load the description of the task/project',
      setDescription: 'Failed to save the description of the task/project',
    },
    errorValidationMessages: {
      skillType: 'Select at least one skills type',
      selectExperts: 'There are specializations for which no expert has been selected',
      noExperts: 'No expert has been selected',
      selectApprover: 'Select one supervisor who should approve the assessment 360',
    },
    changeTests360SettingsDialog: {
      title: 'Configuring the assessment assignment',
      successMessage: 'Configuration successfully saved',
      errorMessages: {
        getTests360Settings: 'Failed to get configuration',
        changeTests360Settings: 'Failed to save configuration',
      },
    },
  },
};
